<div *ngIf="categories && categories.length"
     #categoryChildrenContainer
     [mmTestId]="'PRODUCT_CATALOG.CATEGORY_CHILDREN_TILES'"
     class="category-children"
     fxLayout="row"
     fxLayoutAlign="start center">

  <div *ngIf="categoriesCalculationIsDone"
       class="category-children__items"
       [fxLayout]="!isMobileOrTablet ? 'row wrap' : (showAllCategories ? 'column' : 'row')"
       [fxLayoutAlign]="(isMobileOrTablet && showAllCategories) ? 'start start' : 'start center'">

    <ng-container *ngFor="let category of categories; let i = index; trackBy: trackById">
      <a class="category-children__items__item"
           fxLayout="row"
           *ngIf="showAllCategories || i < lastCategoryToShowIndex"
           [routerLink]="[categoryRoute, category?.slug]"
           (click)="onSelectCategory(category)">

        <div class="category-children__items__item__image"
             fxLayoutAlign="center center">
          <img [appDefaultImage]="defaultCategoryImage"
               [alt]="category?.name"
               [appLazyLoadImage]="getSource(category)"
               [srcSet]="getSourceSet(category)">
        </div>
        <div class="category-children__items__item__name"
             fxLayoutAlign="center center">
          {{category.name}}
        </div>
      </a>
    </ng-container>
  </div>

  <div
    *ngIf="isShowAllButtonVisible && categoriesCalculationIsDone"
    class="category-children__show-all"
    fxLayoutAlign="center center"
    (click)="onClickShowAll()">
      {{ 'CATALOG.CATALOG_PAGE.HUB.SHOW_ALL' | translate }}
    <mm-icon name="arrow-down"></mm-icon>
  </div>
</div>
